import { createContext, useContext, useState, useEffect, useCallback } from "react";

// Rates: how many UNIT of target currency = 1 XAF (base)
// (approximate, static; can be moved to admin settings later)
const RATES = {
  XAF: { rate: 1, symbol: "XAF", locale: "fr-FR", position: "after" },
  XOF: { rate: 1, symbol: "XOF", locale: "fr-FR", position: "after" }, // pegged same as XAF
  EUR: { rate: 1 / 655.957, symbol: "€", locale: "fr-FR", position: "before" },
  USD: { rate: 1 / 600, symbol: "$", locale: "en-US", position: "before" },
  GBP: { rate: 1 / 760, symbol: "£", locale: "en-GB", position: "before" },
  CAD: { rate: 1 / 440, symbol: "C$", locale: "en-CA", position: "before" },
  MAD: { rate: 1 / 60, symbol: "MAD", locale: "fr-FR", position: "after" }, // Moroccan Dirham
  NGN: { rate: 2.5, symbol: "₦", locale: "en-NG", position: "before" }, // Nigerian Naira approx
  ZAR: { rate: 1 / 34, symbol: "R", locale: "en-ZA", position: "before" },
};

export const CURRENCIES = Object.keys(RATES);

const CurrencyCtx = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try { return localStorage.getItem("mbk_currency") || "XAF"; } catch { return "XAF"; }
  });
  const setCurrency = useCallback((c) => {
    setCurrencyState(c);
    try { localStorage.setItem("mbk_currency", c); } catch {}
  }, []);
  const convert = useCallback((amountXaf) => {
    if (amountXaf == null) return 0;
    const r = RATES[currency] || RATES.XAF;
    return amountXaf * r.rate;
  }, [currency]);
  const fmt = useCallback((amountXaf) => {
    if (amountXaf == null) return "-";
    const r = RATES[currency] || RATES.XAF;
    const val = amountXaf * r.rate;
    const decimals = currency === "XAF" || currency === "XOF" ? 0 : 2;
    const formatted = new Intl.NumberFormat(r.locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(val);
    return r.position === "before" ? `${r.symbol}${formatted}` : `${formatted} ${r.symbol}`;
  }, [currency]);
  return (
    <CurrencyCtx.Provider value={{ currency, setCurrency, fmt, convert, symbol: RATES[currency]?.symbol || "XAF" }}>
      {children}
    </CurrencyCtx.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyCtx);
